import React, {Component} from 'react';
import {
    withStyles, Button, Dialog, DialogActions, 
    DialogContent, DialogTitle, Typography,
    Grid, TextField, MenuItem
} from 'material-ui';
import styles from './style/styles';

class UnpublishPageDialog extends Component {

    render() {
        const {
            handleSubmit,
            handleRequestClose,
            open,
            classes,
            pageTitle,
            statuses,
            selectedStatus,
            selectStatusCode,
            redirectUrl,
            updateRedirectUrl,
            clearRedirectUrl
        } = this.props;

        let disableButton = false;

        if (selectedStatus.length < 1) {
            disableButton = true;
        }

        if (selectedStatus === 1 && redirectUrl.length < 1) {
            disableButton = true;
        }

        let selectHasError = (selected, name) => {
            let selectError = {};

            if (selected === undefined) {
                selectError = {[name]: true};
                disableButton = true;
            } else {
                if (selected.toString().length < 1) {
                    selectError = {[name]: true};
                }
        
                if (selected.toString().length > 0) {
                    selectError = {[name]: false};
                }
            }

            return selectError[name];
        };

        return (
            <Dialog
                open={open}
                onClose={handleRequestClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>{'Unpublish Page: "' + pageTitle + '"'}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <Typography variant="body2">Before you can unpublish this page, please choose a redirect option below:</Typography>
                        </Grid>
                        <Grid container spacing={0} id="select-field">
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    id="select-status"
                                    name="status"
                                    label="Select Status Code"
                                    fullWidth
                                    value={selectedStatus || 0}
                                    onChange={(event) => {
                                        selectStatusCode(event.target.value);
                                        clearRedirectUrl();
                                    }}
                                    className={classes.pageTypeSelects}
                                    required
                                    error={selectHasError(selectedStatus, "status")}
                                    helperText={selectHasError(selectedStatus, "status") ? "Please select at least one Status Code!" : "Select Status Code from the drop-down"}
                                >
                                {statuses.map(option => (
                                    <MenuItem key={option.id} value={Number(option.code)} className={classes.selectMenuItem}>
                                        {option.code + ' - ' + option.display_name}
                                    </MenuItem>
                                ))}
                                </TextField>
                            </Grid>
                            {selectedStatus === 301 &&
                                <Grid item xs={12}>
                                    <TextField
                                        name="redirect_to"
                                        id="redirect-to"
                                        autoFocus
                                        margin="dense"
                                        label="Redirect To URL"
                                        fullWidth
                                        value={redirectUrl || ''}
                                        onChange={(event) => {
                                            updateRedirectUrl(event.target.value);
                                        }}
                                        error={selectHasError(redirectUrl, "redirect_to")}
                                        helperText={selectHasError(redirectUrl, "redirect_to") ? "Please fill in the Redirect To URL! e.g. /volunteer-teaching/" : "e.g. /volunteer-teaching/"}
                                        className={classes.pageTypeSelects}
                                        required
                                    >
                                    </TextField>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button onClick={handleRequestClose} variant="raised">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="raised"
                        color="primary"
                        type="submit"
                        disabled={disableButton}
                    >
                        Done
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(UnpublishPageDialog);



// WEBPACK FOOTER //
// ./src/containers/pages/PageUnpublishDialog.jsx